export default __webpack_public_path__ + "static/media/img.cbdd7aed.png";